/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import * as types from "./types";

export const state = {
  errors: {},
  activeNew: false,
  balance: 0,
  anticipationRule: null,
  anticipationTax: null,
  accountTaxes: {},
  accountTaxBrands: [],
  accountTaxSelectedBrand: null,
  accountPayers: {},
  accountLends: {},
  anticipationsAvailable: [],
  anticipationsAvailableCount: 0,
  currentTax: 0,
  selectedAnticipations: [],
  selectedAnticipationsAmount: 0,
  anticipationsAvailableLimit: 5,
  anticipationsAvailablePage: 1,
  isLoad: false,
  loading: false,
  account: {},
  logoLink: "",
  favicon: "",
  color: null,
  partnerName: process.env.VUE_APP_APP_NAME || "FlowIt",
  partnerurl: "",
  partner: "establishment",
  notifications: [],
  notificationsVisible: false,
  newLend: [],
  newLendStatus: false,
  newLendError: false,
  showLogoForm: false,
  showFaviconForm: false,
  showColorForm: false,
  showForm: false,
  showSuccess: false,
  showError: false,
  isBillPaymentEnabled: false,
  isInvoicePaymentEnabled: false,
  isDarfPaymentEnabled: false,
  isLinkPaymentEnabled: false,
  isManualSaleEnabled: false,
  isRecurringPaymentEnabled: false,
  isRechargeEnabled: false,
  successStatus: false,
  errorStatus: false,
  successMessage: "",
  errorMessage: ""
};

export const mutations = {
  [types.BALANCE](state, balance) {
    state.balance = balance;
  },
  [types.NOTIFICATIONS](state, notifications) {
    state.notifications = notifications;
  },
  [types.NOTIFICATIONS_VISIBLE](state, notificationsVisible) {
    state.notificationsVisible = notificationsVisible;
  },
  [types.ACCOUNT](state, account) {
    state.account = account;
  },
  [types.LOGO_LINK](state, logoLink) {
    state.logoLink = logoLink;
  },
  [types.FAVICON](state, favicon) {
    state.favicon = favicon;
  },
  [types.COLOR](state, color) {
    state.color = color;
  },
  [types.PARTNER_NAME](state, partnerName) {
    state.partnerName = partnerName;
  },
  [types.PARTNER_URL](state, partnerUrl) {
    state.partnerUrl = partnerUrl;
  },
  [types.PARTNER](state, partner) {
    state.partner = partner;
  },
  [types.ACCOUNT_TAXES](state, taxes) {
    state.accountTaxes = taxes;
  },
  [types.ACCOUNT_TAX_BRANDS](state, brands) {
    state.accountTaxBrands = brands || [];
  },
  [types.ACCOUNT_TAX_SELECTED_BRAND](state, brand) {
    state.accountTaxSelectedBrand = brand;
  },
  [types.ACCOUNT_PAYERS](state, payers) {
    state.accountPayers = payers;
  },
  [types.ACCOUNT_LENDS](state, lends) {
    state.accountLends = lends;
  },
  [types.ANTICIPATION_RULE](state, rule) {
    state.anticipationRule = rule;
  },
  [types.ANTICIPATION_TAX](state, tax) {
    state.anticipationTax = tax;
  },
  [types.ANTICIPATIONS_AVAILABLE](state, anticipationsAvailable) {
    state.anticipationsAvailable = anticipationsAvailable;
  },
  [types.ANTICIPATIONS_AVAILABLE_COUNT](state, anticipationsAvailableCount) {
    state.anticipationsAvailableCount = anticipationsAvailableCount;
  },
  [types.CURRENT_TAX](state, currentTax) {
    state.currentTax = currentTax;
  },
  [types.SELECTED_ANTICIPATIONS](state, selectedAnticipations) {
    state.selectedAnticipations = selectedAnticipations;
  },
  [types.SELECTED_ANTICIPATIONS_AMOUNT](state, selectedAnticipationsAmount) {
    state.selectedAnticipationsAmount = selectedAnticipationsAmount;
  },
  [types.ANTICIPATIONS_AVAILABLE_LIMIT](state, anticipationsAvailableLimit) {
    state.anticipationsAvailableLimit = anticipationsAvailableLimit;
  },
  [types.ANTICIPATIONS_AVAILABLE_PAGE](state, anticipationsAvailablePage) {
    state.anticipationsAvailablePage = anticipationsAvailablePage;
  },
  [types.ANTICIPATIONS_AVAILABLE_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.LOADING](state, loading) {
    state.loading = loading;
  },
  [types.IS_LOAD](state, isLoad) {
    state.isLoad = isLoad;
  },
  [types.LEND](state, newLend) {
    state.newLend = newLend;
  },
  [types.NEW_LEND_STATUS](state, newLendStatus) {
    state.newLendStatus = newLendStatus;
  },
  [types.NEW_LEND_ERROR](state, newLendError) {
    state.newLendError = newLendError;
  },
  [types.ERRORS](state, errors) {
    state.errors = errors;
  },
  [types.SHOW_LOGO_FORM](state, params) {
    state.showLogoForm = params;
  },
  [types.SHOW_FAVICON_FORM](state, params) {
    state.showFaviconForm = params;
  },
  [types.SHOW_COLOR_FORM](state, params) {
    state.showColorForm = params;
  },
  [types.SHOW_FORM](state, params) {
    state.showForm = params;
  },
  [types.SHOW_ERROR](state, showError) {
    state.showError = showError;
  },
  [types.SHOW_SUCCESS](state, showSuccess) {
    state.showSuccess = showSuccess;
  },
  [types.ACTIVE_NEW](state, activeNew) {
    state.activeNew = activeNew;
  },
  [types.IS_BILL_PAYMENT_ENABLED](state, isBillPaymentEnabled) {
    state.isBillPaymentEnabled = isBillPaymentEnabled;
  },
  [types.IS_INVOICE_PAYMENT_ENABLED](state, isInvoicePaymentEnabled) {
    state.isInvoicePaymentEnabled = isInvoicePaymentEnabled;
  },
  [types.IS_DARF_PAYMENT_ENABLED](state, isDarfPaymentEnabled) {
    state.isDarfPaymentEnabled = isDarfPaymentEnabled;
  },
  [types.IS_LINK_PAYMENT_ENABLED](state, isLinkPaymentEnabled) {
    state.isLinkPaymentEnabled = isLinkPaymentEnabled;
  },
  [types.IS_MANUAL_SALE_ENABLED](state, isManualSaleEnabled) {
    state.isManualSaleEnabled = isManualSaleEnabled;
  },
  [types.IS_RECURRING_PAYMENT_ENABLED](state, isRecurringPaymentEnabled) {
    state.isRecurringPaymentEnabled = isRecurringPaymentEnabled;
  },
  [types.IS_RECHARGE_ENABLED](state, isRechargeEnabled) {
    state.isRechargeEnabled = isRechargeEnabled;
  },
  [types.SUCCESS_STATUS](state, successStatus) {
    state.successStatus = successStatus;
  },
  [types.ERROR_STATUS](state, errorStatus) {
    state.errorStatus = errorStatus;
  },
  [types.SUCCESS_MESSAGE](state, successMessage) {
    state.successMessage = successMessage;
  },
  [types.ERROR_MESSAGE](state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  [types.LOAD](state, loading) {
    state.loading = loading;
  }
};
